import { useTu } from "@src/appV2/i18n/useTu";
import { Box, Stack } from "@mui/material";
import { BerlinTimePicker } from "@src/appV2/redesign/components/BerlinTimePicker/BerlinTimePicker";
import { Text } from "@src/appV2/redesign/components/Text";

interface TimeSlotSelectorProps {
  startTime: Date;
  endTime: Date;
  startTimeError?: string;
  endTimeError?: string;
  timezone?: string;
  onStartTimeChange: (time: Date) => void;
  onEndTimeChange: (time: Date) => void;
}

export function TimeSlotSelector(props: TimeSlotSelectorProps) {
  const { tu } = useTu("schedule");

  const {
    startTime,
    endTime,
    startTimeError,
    endTimeError,
    timezone,
    onStartTimeChange,
    onEndTimeChange,
  } = props;

  return (
    <Stack direction="row" spacing={5}>
      <Box sx={{ display: "flex", flexDirection: "column", gap: "2px", flex: 1 }}>
        <Text
          semibold
          sx={(theme) => ({
            color: theme.palette.text.secondary,
            fontSize: theme.typography.caption.fontSize,
          })}
          variant="caption"
        >
          {tu("Start time")}
        </Text>
        <BerlinTimePicker
          ariaLabel="Shift start time"
          hasError={Boolean(startTimeError)}
          timezone={timezone}
          value={startTime}
          sx={{ width: "100%" }}
          onChange={onStartTimeChange}
        />
        {startTimeError && (
          <Text
            color="error"
            sx={(theme) => ({
              marginTop: theme.spacing(1),
            })}
            variant="caption"
          >
            {startTimeError}
          </Text>
        )}
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", gap: "2px", flex: 1 }}>
        <Text
          semibold
          sx={(theme) => ({
            color: theme.palette.text.secondary,
            fontSize: theme.typography.caption.fontSize,
          })}
          variant="caption"
        >
          {tu("End time")}
        </Text>
        <BerlinTimePicker
          ariaLabel="Shift end time"
          hasError={Boolean(endTimeError)}
          timezone={timezone}
          value={endTime}
          sx={{ width: "100%" }}
          onChange={onEndTimeChange}
        />
        {endTimeError && (
          <Text
            color="error"
            sx={(theme) => ({
              marginTop: theme.spacing(1),
            })}
            variant="caption"
          >
            {endTimeError}
          </Text>
        )}
      </Box>
    </Stack>
  );
}
